/**
 *
 * @param Number|String num 需要修改的数字
 * @param Number counter 需要保留的位数
 * @return @if counter === 0 Number int
 *         @if counter === -1 String
 */
export default function (num, counter = -1) {
  num = Number(num)

  if (isNaN(num)) return 0

  if (counter === 0) {
    return parseInt(num)
  } else if (counter > 0) {
    const times = Math.pow(10, counter)
    const n = Math.round(parseFloat(num * times)) / times
    const part = `${n}`.split('.')

    if (part.length === 1) { // 没有小数位数
      const arr = Array.from({ length: counter })
      return `${part[0]}.${arr.fill(0).join('')}`
    } else {
      const arr = Array.from({ length: counter - part[1].length })
      return `${part.join('.')}${arr.fill(0).join('')}`
    }
  } else if (counter === -1) {
    return `${num}`
  } else {
    return 0
  }
}
